






















import { Component, Vue, Watch } from "vue-property-decorator";
import CustomerInfo from "@/components/cutomer/mypage/customerInfo.vue";
import History from "@/components/cutomer/mypage/history.vue";

@Component({
  name: "MyPage",
  components: {
    CustomerInfo,
    History,
  },
})
export default class MyPage extends Vue {
  public hash = "";
  created() {
    this.hash = this.$router.currentRoute.hash;
    if (this.hash.length === 0) {
      this.hash = "#history";
    }
  }

  @Watch("$route.currentRoute", { deep: true, immediate: true })
  changeHash() {
    this.hash = this.$router.currentRoute.hash;
  }

  get getComponent() {
    return this.hash == "#info" ? "CustomerInfo" : "History";
  }

  isSelect(hash) {
    return this.hash == hash ? true : false;
  }

  getSelect(hash) {
    return this.isSelect(hash) ? "select" : "";
  }
}
